<ng-container *ngIf="_data">
  <button
    (click)="op.toggle($event)"
    [ngClass]="{
      'is-active': optionsSelectedCount
    }"
    [disabled]="isDisabled"
    class="container"
  >
    <span class="label">
      {{ selectedOptionLabel || _data.filterLabel }}
    </span>
    <button *ngIf="!optionsSelectedCount" class="toggle-btn">
      <i class="pi pi-chevron-down icon"></i>
    </button>
    <div *ngIf="optionsSelectedCount" class="counter-selected-options">
      <span>
        {{ optionsSelectedCount }}
      </span>
    </div>

    <div *ngIf="isDisabled" class="container__disabled-shadow"></div>
  </button>

  <p-overlayPanel #op (onShow)="onShowDropdown()">
    <div class="container-filters" [style.width.px]="_data.panelWidthPx || 310">
      <span class="container-filters__title">
        {{ _data.dropdownLabel }}
      </span>

      <div *ngIf="isVisibleSearchInput" class="container-filters__search">
        <span class="p-input-icon-left">
          <i class="pi pi-search icon"></i>
          <input
            type="text"
            pInputText
            [placeholder]="'labels.search' | translate | titlecase"
            [(ngModel)]="searchValue"
            (ngModelChange)="searchInputValue$.next($event)"
          />
        </span>
      </div>

      <div class="container-filters__list" #listContainer>
        <ng-container *ngIf="!isGroupedData">
          <ng-container
            *ngFor="
              let item of searchValuePipe
                | filterArrByPropValue : _data.options : 'label';
              let i = index
            "
          >
            <ng-container
              [ngTemplateOutlet]="renderItem"
              [ngTemplateOutletContext]="{
                data: item,
                index: i,
                filterLabel: _data.filterLabel
              }"
            >
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="isGroupedData">
          <ng-container
            [ngTemplateOutlet]="treeNodes"
            [ngTemplateOutletContext]="{
              nodes: $any(groupedOptionsToRender),
              level: 0
            }"
          ></ng-container>
        </ng-container>

        <ng-template #treeNodes let-nodes="nodes" let-level="level">
          <ng-container *ngFor="let node of $any(nodes)">
            <ng-container *ngIf="isGroupNode(node); else leafNode">
              <div class="group-wrapper">
                <div
                  class="group-title"
                  [style.paddingLeft.px]="level * 12"
                  (click)="toggleGroup(node, level, $event)"
                >
                  <span class="group-title__arrow">
                    <i
                      class="pi"
                      [ngClass]="
                        isExpanded(node, level)
                          ? 'pi-chevron-down'
                          : 'pi-chevron-right'
                      "
                    ></i>
                  </span>

                  <span class="group-title__text">
                    {{ node.label }}
                  </span>
                </div>

                <ng-container *ngIf="isExpanded(node, level)">
                  <ng-container
                    [ngTemplateOutlet]="treeNodes"
                    [ngTemplateOutletContext]="{
                      nodes: node.children,
                      level: level + 1
                    }"
                  ></ng-container>
                </ng-container>
              </div>
            </ng-container>

            <ng-template #leafNode>
              <div class="leaf-wrapper" [style.paddingLeft.px]="level * 12">
                <ng-container
                  [ngTemplateOutlet]="renderItem"
                  [ngTemplateOutletContext]="{
                    data: node,
                    index: 0,
                    filterLabel: _data.filterLabel
                  }"
                ></ng-container>
              </div>
            </ng-template>
          </ng-container>
        </ng-template>
      </div>

      <div
        *ngIf="maxSelectable && selectedCheckboxCount >= maxSelectable"
        class="container-filters__max-options-selected"
      >
        <span class="container-filters__max-options-selected__title">
          <i class="pi pi-info-circle icon"></i>
          {{ "theMaximumParameter" | translate : { value: maxSelectable } }}
        </span>
      </div>

      <div
        *ngIf="_data.type === FILTER_VEHICLE_TYPE.MultipleCheckbox"
        class="container-filters__actions"
      >
        <p-button
          (onClick)="submit(op)"
          class="submit"
          [label]="'labels.apply' | translate"
        ></p-button>
        <button (click)="clearFilters(op)" class="cancel">
          {{ "labels.clear" | translate }}
        </button>
      </div>
    </div>
  </p-overlayPanel>

  <ng-template
    #renderItem
    let-data="data"
    let-index="index"
    let-filterLabel="filterLabel"
  >
    <ng-container [ngSwitch]="_data.type">
      <div *ngSwitchCase="FILTER_VEHICLE_TYPE.Status">
        <div
          *ngTemplateOutlet="
            statusModeControl;
            context: { data: data, filterLabel: filterLabel, index: index }
          "
        ></div>
      </div>

      <div *ngSwitchCase="FILTER_VEHICLE_TYPE.Group">
        <div
          *ngTemplateOutlet="
            groupModeControl;
            context: { data: data, filterLabel: filterLabel, index: index }
          "
        ></div>
      </div>

      <div *ngSwitchCase="FILTER_VEHICLE_TYPE.Blocking">
        <div
          *ngTemplateOutlet="
            groupModeControl;
            context: { data: data, filterLabel: filterLabel, index: index }
          "
        ></div>
      </div>

      <div *ngSwitchCase="FILTER_VEHICLE_TYPE.TachoStatus">
        <div
          *ngTemplateOutlet="
            statusModeControl;
            context: { data: data, filterLabel: filterLabel, index: index }
          "
        ></div>
      </div>

      <div *ngSwitchCase="FILTER_VEHICLE_TYPE.MultipleCheckbox">
        <div
          *ngTemplateOutlet="
            multipleSelectControl;
            context: { data: data, filterLabel: filterLabel, index: index }
          "
        ></div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #statusModeControl let-data="data" let-filterLabel="filterLabel">
    <div class="control-wrapper">
      <p-radioButton
        appRadioCheckboCustomColor
        [colorCheckbox]="data.checkboxColor || '#2d78ff'"
        (ngModelChange)="onSelectRadioButton(data)"
        [(ngModel)]="_selectedControlValue"
        [name]="filterLabel"
        [value]="data.value"
        styleClass="filters-vehicle-checkbox-selected-style"
        [inputId]="filterLabel + '-' + getIndexForValue(data.value)"
        size="large"
      ></p-radioButton>

      <label
        [for]="filterLabel + '-' + getIndexForValue(data.value)"
        class="control-wrapper__label"
      >
        {{ data.label }}
      </label>
    </div>
  </ng-template>

  <ng-template #groupModeControl let-data="data" let-filterLabel="filterLabel">
    <div class="control-wrapper">
      <p-radioButton
        appRadioCheckboCustomColor
        (ngModelChange)="onSelectRadioButton(data)"
        [(ngModel)]="_selectedControlValue"
        [name]="filterLabel"
        [value]="data.value"
        styleClass="filters-vehicle-checkbox-selected-style"
        [inputId]="filterLabel + '-' + getIndexForValue(data.value)"
        size="large"
      ></p-radioButton>

      <label
        [for]="filterLabel + '-' + getIndexForValue(data.value)"
        class="control-wrapper__label"
      >
        {{ data.label }}
      </label>
    </div>
  </ng-template>

  <ng-template
    #multipleSelectControl
    let-data="data"
    let-filterLabel="filterLabel"
    let-index="index"
  >
    <div class="control-wrapper">
      <p-checkbox
        [(ngModel)]="checkboxValues[getIndexForValue(data.value)].checkboxValue"
        (onChange)="onCheckboxChange()"
        [binary]="true"
        [disabled]="
          !!maxSelectable &&
          !checkboxValues[getIndexForValue(data.value)].checkboxValue &&
          selectedCheckboxCount >= maxSelectable
        "
        [inputId]="filterLabel + '-' + getIndexForValue(data.value)"
      ></p-checkbox>
      <label
        [for]="filterLabel + '-' + getIndexForValue(data.value)"
        class="control-wrapper__label"
      >
        {{ data.label }}
      </label>
    </div>
  </ng-template>
</ng-container>
